import React, { Component } from 'react';
import makeAnimated from "react-select/animated";
import Select from "react-select";
import axios from "axios";
import apiUrl from "../../../shared/config";

class AuthorInput extends Component {
    state = {
        authors: [],
        isLoading: true
    };

    componentDidMount() {
        if (this.state.authors.length === 0  && !this.props.authorsArr) {
                axios.get(apiUrl + 'Users/getUsers')
                    .then(response => {
                        this.setState({ authors: response.data, isLoading: false });
                    });
        }
        if (this.state.isLoading && this.props.authorsArr && this.props.authorsArr.length > 0) {
            this.setState({authors: this.props.authorsArr, isLoading: false})
        }
        if ((!this.props.authors_filter || this.props.authors_filter.length === 0) && this.props.userId > 0) {
            this.props.authorsUpdate([{ value: parseInt(this.props.userId) }]);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.patternEdit && this.props.authors_filter && this.props.authors_filter.length === 0 && this.props.userId > 0) {
            this.props.authorsUpdate([{ value: parseInt(this.props.userId) }]);
        }
        if (this.state.isLoading && this.props.authorsArr && this.props.authorsArr.length > 0) {
            this.setState({authors: this.props.authorsArr, isLoading: false})
        }
    }

    render() {
        const { authors, isLoading } = this.state;

        // Display loading or placeholder message if data is still being fetched
        if (isLoading) {
            return <Select isMulti isSearchable placeholder="Loading authors..." />;
        }

        const authorOptions = authors.map(author => ({ value: author.user_id, label: author.display_name, color: '#9999FF' }));
        const animatedComponents = makeAnimated();
        // const userArray = this.props.userId !== null ? [parseInt(this.props.userId)] : [];
        // let authors_filter = (this.props.authors_filter && this.props.authors_filter.length > 0)
        //     ? this.props.authors_filter
        //     : userArray;

        const defaultOptions = this.props.authors_filter.map(user_id => {
            let author_object = this.state.authors.find(author_list => author_list.user_id === user_id) || { user_id: null, display_name: '' };
            return ({ value: author_object.user_id, label: author_object.display_name, color: '#9999FF' });
        });

        return (
            <span key={this.props.authors_filter.toString()}>
                <Select
                    isMulti
                    isSearchable
                    options={authorOptions}
                    defaultValue={defaultOptions}
                    closeMenuOnSelect={false}
                    components={animatedComponents}
                    placeholder={this.props.selectorText ?? "Select authors for this pattern."}
                    onChange={(val) => {
                        // console.log('Normal Author Update: ', val);
                        this.props.authorsUpdate(val);
                        this.props.updatePage(0);
                        this.props.closePatternDetails(null);
                    }}
                />
            </span>
        );
    }
}

export default AuthorInput;
